import React, { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { InvitationStatus, BuyerInfoUser } from '@/types';
import theme from './ResidentialExpandedListItem.module.scss';
import { Button, SlideToggle } from '@ygtechnologies/rubus-ui';
import { YesNoDialog } from '@/components/dialogs';
import { DateDisplay } from '@/components/localization';

interface BuyerActionsProps {
    buyer: BuyerInfoUser;
    onSendInvite: (buyer: BuyerInfoUser, sendEmail: boolean, sendSms: boolean) => void;
}

const BuyerActions: React.FC<BuyerActionsProps> = ({
    buyer,
    onSendInvite,
}) => {
    const [showSendInviteDialog, setShowSendInviteDialog] = useState(false);
    const [showResendInviteDialog, setShowResendInviteDialog] = useState(false);
    const [sendSms, setSendSms] = useState(false);
    const [sendEmail, setSendEmail] = useState(true);
    switch (buyer.inviteStatus) {
        case InvitationStatus.Sent:
            return (
                <div className={theme.buyerActions}>
                    <Button
                        variant="link"
                        className={theme.actionButton}
                        onClick={() => setShowResendInviteDialog(true)}
                    >
                        <Trans>Resend invitation</Trans>
                    </Button>
                    <YesNoDialog
                        title={<Trans>Resend invitation to {buyer.email}</Trans>}
                        show={showResendInviteDialog}
                        onClose={() => setShowResendInviteDialog(false)}
                        body={<div className={theme.slideToggleDialogBody}>
                            {buyer.invitedDate && (
                                <p style={{ marginBottom: '16px' }}>
                                    <Trans>Invitation sent: <DateDisplay value={buyer.invitedDate} /></Trans>
                                </p>
                            )}
                            <SlideToggle
                                checked={sendEmail}
                                onChange={(e) => setSendEmail(e.target.checked)}
                            >
                                <Trans>Resend to {buyer.email}</Trans>
                            </SlideToggle>
                            {buyer.phoneNumber && (
                                <SlideToggle
                                    checked={sendSms}
                                    onChange={(e) => setSendSms(e.target.checked)}
                                >
                                    <Trans>Resend to {buyer.phoneNumber}</Trans>
                                </SlideToggle>
                            )}
                        </div>}
                        disableAccept={!sendEmail}
                        disableReason={<Trans>Email is required</Trans>}
                        onAccept={() => onSendInvite(buyer, sendEmail, sendSms)}
                    />
                </div>
            );
        case InvitationStatus.Pending:
            return (
                <div className={theme.buyerActions}>

                    <Button
                        variant="link"
                        className={theme.actionButton}
                        onClick={() => setShowSendInviteDialog(true)}
                    >
                        <Trans>Send invite</Trans>
                    </Button>
                    <YesNoDialog
                        title={<Trans>Send invite to {buyer.email}</Trans>}
                        show={showSendInviteDialog}
                        onClose={() => setShowSendInviteDialog(false)}
                        body={<div className={theme.slideToggleDialogBody}>
                            <SlideToggle
                                disabled={true}
                                checked={sendEmail}
                            >
                                <Trans>Send invitation to {buyer.email}</Trans>
                            </SlideToggle>
                            {buyer.phoneNumber && (
                                <SlideToggle
                                    checked={sendSms}
                                    onChange={(e) => setSendSms(e.target.checked)}
                                >
                                    <Trans>Send invitation to {buyer.phoneNumber}</Trans>
                                </SlideToggle>
                            )}
                        </div>}
                        onAccept={() => onSendInvite(buyer, sendEmail, sendSms)}
                    />

                </div>
            );
        default:
            return null;
    }
};

export default BuyerActions; 